import { render, staticRenderFns } from "./BaseTBody.vue?vue&type=template&id=02860fab&"
import script from "./BaseTBody.vue?vue&type=script&lang=js&"
export * from "./BaseTBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports